import { lazy } from 'react';

import { withSuspense } from '@/shared/lib/hocs/with-suspense.hoc';
import { PageLoader } from '@/widgets/page';

export const YachtViewAreaPage = withSuspense(
	lazy(async () => await import('./yacht-view-area-page.component')),
	PageLoader,
);
